import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { DeviceSettingsService } from '../../../library/device-settings.service';
import { ControlService } from '../../../library/control.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { CallStoreService } from '../../../library/call-store/call-store.service';
import { AppConstants } from 'src/app/app-constants';
@Component({
  selector: 'app-visual-aid-device-settings-content',
  templateUrl: './visual-aid-device-settings-content.component.html',
  styleUrls: ['./visual-aid-device-settings-content.component.scss'],
  standalone: false,
  providers: [
      {
        provide: TRANSLOCO_SCOPE,
        useValue: 'settings'
      },
    ]
})
export class VisualAidDeviceSettingsContentComponent implements OnInit, OnDestroy {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;
  @Output() diagnosticRunningChange = new EventEmitter<boolean>();
  isTavusCall: boolean = false;

  constructor(
    private controlService: ControlService,
    private callStore: CallStoreService,
  ) { }

  ngOnInit(): void {
    this.isTavusCall = this.controlService?.isRealTimeCall;
  }

  ngOnDestroy(): void {
    if (this.deviceSettingsService) {
      this.deviceSettingsService.stopDeviceSettings(false);
    }
  }

  get isCallActive(): boolean {
    const currentView = this.callStore.getCurrentView();
    const isPracticeView = currentView === AppConstants.VIEW_PRACTICE;
    const isCallEnded = this.callStore.getDisplayPostCall();
    return isPracticeView && !isCallEnded;
  }
}
